import { ErrorPage } from '@/pages/CustomerDashboard/ErrorPage';
import React, { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode,
}

interface State {
  hasError: boolean,
}

export class DashboardErrorBoundary extends Component<Props, State> {
  constructor ( props: Props ) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError (): State {
    return { hasError: true };
  }

  componentDidCatch (error: Error, errorInfo: React.ErrorInfo): void {
    console.error('Dashboard error:', error, errorInfo);
  }

  render (): ReactNode {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}
